import ColorSchema from "../kits/Color";
import { CustomInput } from "../kits/Inputs/Inputs";

export default function RecipientData({ data, dispatch, ACTIONS }) {
  return (
    <div
      className="p-2 d-flex flex-wrap"
      style={{
        border: `1px solid ${ColorSchema.primary_custom}`,
        borderRadius: "10px",
      }}
    >
      <div className="col-6 col-sm-4 col-md-2 px-1">
        <CustomInput
          label="نام و نام خانوادگی"
          inputType="input"
          inputValue={data?.recipient_data?.fullname}
          onChangeFunc={(e) =>
            dispatch({
              type: ACTIONS.CHANGERECI,
              payload: { fullname: e.target.value },
            })
          }
        />
      </div>
      <div className="col-6 col-sm-4 col-md-2 px-1">
        <CustomInput
          label="موبایل"
          inputType="input"
          inputValue={data?.recipient_data?.mobile}
          onChangeFunc={(e) =>
            dispatch({
              type: ACTIONS.CHANGERECI,
              payload: { mobile: e.target.value },
            })
          }
        />
      </div>
      <div className="col-4 col-sm-4 col-md-2 px-1">
        <CustomInput
          label="کدپستی"
          inputType="input"
          inputValue={data?.recipient_data?.postalCode}
          onChangeFunc={(e) =>
            dispatch({
              type: ACTIONS.CHANGERECI,
              payload: { postalCode: e.target.value },
            })
          }
        />
      </div>
      <div className="col-8 col-sm-12 col-md-3 px-1 flex-grow-1">
        <CustomInput
          label="آدرس"
          inputType="textarea"
          inputValue={data?.recipient_data?.address}
          onChangeFunc={(e) =>
            dispatch({
              type: ACTIONS.CHANGERECI,
              payload: { address: e.target.value },
            })
          }
        />
      </div>
    </div>
  );
}
